import { FC, useState, useMemo } from 'react';
import { useStore } from 'hooks/useRootStore';
import { useAppPreloader } from 'hooks/useAppPreloader';
import { useQuery } from 'react-query';
import { Grid, Paper } from '@material-ui/core';
import { GridColumns, GridCellParams, DataGrid } from '@material-ui/data-grid';
import { useStyles } from './styles';
import { observer } from 'mobx-react-lite';
import EmailIcon from '../../../assets/icons/EndUser/Email.svg';
import { getRowsPerPageOptions } from 'utils/pagination';
import { Search } from 'components/Search';
import IconButton from '@material-ui/core/IconButton';
import { Button } from '@material-ui/core';
// import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import HomeWorkIcon from '@material-ui/icons/HomeWork';
import { useMutation } from 'react-query';
import { UserData } from './types';
import { useForm } from 'react-hook-form';
import { handleCompanyUrl } from 'utils/organizationUtils';
import { useHistory } from 'react-router';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';

export const UserTable: FC<any> = observer(() => {
  const {
    groupTableStore: { usergroupsView },
    userTableStore: { createUserGroup },
    ldapStore: { usersView, getUsers, setUsersKeywordFilter },
    endUserSettingsFormStore: { getPortalSettings },
    notificationStore: { openNotification },
  } = useStore();
  const history = useHistory();

  const getUsersReq = useQuery('getUsersReq', () => getUsers(), {
    onError: (error: any) => {
      const errorMessage = error?.response?.data?.message || error?.message || `Can't get users`;
      openNotification('error', errorMessage);
    },
  });
  const classes = useStyles();
  const [CurrentGroup] = useState<any>(JSON.parse(localStorage.getItem('CurrentGroup') as string));

  const portalSettingsgetReq = useQuery('portalSettingsgetReq', () => getPortalSettings(), {
    onError: (error: any) => {
      const errorMessage = error?.response?.data?.message || error?.message || `Can't get data`;
      openNotification('error', errorMessage);
    },
  });
  const endUserConfigSettings = JSON.parse(localStorage.getItem('endUserConfigSettings') as string);
  const userId = endUserConfigSettings?.userId;
  // const getUserGroupReq = useQuery('getUserGroup', () => getUserGroup(CurrentGroup?.dn), {
  //   onError: (error: Error) => openNotification('error', error.message),
  // });

  const createDepartmentReq = useMutation((data: UserData) => createUserGroup(data, CurrentGroup?.dn), {
    mutationKey: 'createDepartmentReq',
    onSuccess: () => {
      openNotification('success', 'User Add Successfully');
      history.push(handleCompanyUrl('/group/users'));
    },
    onError: (error: any) => {
      const errorMessage = error?.response?.data?.message || error?.message || `Can't add user`;
      openNotification('error', errorMessage);
    },
  });

  const row = useMemo(() => {
    if (!getUsersReq.isFetching) {
      return usersView.filter((user) => !usergroupsView.some((groupUser) => groupUser.uid === user.uid));
    }
    return [];
  }, [getUsersReq.isFetching, usersView, usergroupsView]);

  const [pageSize, setPageSize] = useState(10);
  const rowsPerPageOptions = useMemo(() => getRowsPerPageOptions(row), [row]);
  const columns: GridColumns = [
    { field: 'sn', headerName: 'LAST', flex: 0.5 },
    { field: 'givenname', headerName: 'FIRST', flex: 0.5 },
    {
      field: 'uid',
      headerName: endUserConfigSettings?.userId === null || endUserConfigSettings?.userId === '' ? 'UID' : userId,
      flex: 0.5,
    },
    {
      field: 'mail',
      headerName: 'EMAIL',
      flex: 1,
      renderCell: (params: GridCellParams) => {
        const value = String(params.value ?? '');
        return (
          <div style={{ display: 'flex', gap: '10px' }}>
            <img src={EmailIcon} alt='' />
            {value}
          </div>
        );
      },
    },
  ];

  const { handleSubmit } = useForm<UserData>();

  const [selectedRows, setSelectedRows] = useState<string[]>([]);

  const handleSelectionModelChange = (selection: any) => {
    setSelectedRows(selection.selectionModel as string[]);
  };
  const selectedRowDetails = selectedRows.map((rowId) => row.find((rowData) => rowData.id === parseInt(rowId)));
  const selectedDns = selectedRowDetails.map((rowData) => rowData?.dn).filter(Boolean);
  const selectedmails = selectedRowDetails.map((rowData) => rowData?.mail).filter(Boolean);
  const onSubmit = (data: UserData) => {
    const newData = {
      ...data,
      uuid: selectedDns,
      userEmail: selectedmails,
    };
    createDepartmentReq.mutate(newData);
  };

  useAppPreloader(getUsersReq.isFetching || createDepartmentReq.isLoading || portalSettingsgetReq.isFetching);
  return (
    <>
      <Grid container alignItems='center' className={classes.box}>
        <IconButton
          onClick={() => {
            history.push(handleCompanyUrl('/group/users'));
          }}
        >
          <ChevronLeftIcon />
        </IconButton>
        <h1> Please select one or more User Accounts below to Assign to the Group({CurrentGroup?.cn}) Selected</h1>
      </Grid>
      <Grid container justify='space-between' alignItems='center' className={classes.box}>
        <IconButton aria-label='home' size='small'>
          <HomeWorkIcon />
        </IconButton>
        <Search handelSearch={setUsersKeywordFilter} />
        {!!selectedRows.length && (
          <Button variant='contained' color='primary' onClick={handleSubmit(onSubmit)} style={{ margin: '0 10px' }}>
            Assign to group
          </Button>
        )}
      </Grid>
      {getUsersReq.isFetching ? (
        <></>
      ) : row.length === 0 ? (
        <h1 className={classes.link}> All the users is already linked with this group. </h1>
      ) : (
        <Paper className={classes.dataGrid} elevation={0}>
          <DataGrid
            className={classes.noBorder}
            autoHeight
            rows={row}
            columns={columns}
            pageSize={pageSize}
            rowsPerPageOptions={rowsPerPageOptions}
            pagination
            onPageChange={(params) => setPageSize(params.pageSize)}
            checkboxSelection
            onSelectionModelChange={handleSelectionModelChange}
          />
        </Paper>
      )}
    </>
  );
});
